import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Download from "../excel/Download";
// import { logout } from "../../actions/authActions";

const NavbarLayout = () => {
  return (
    <nav className="navbar navbar-expand-md navbar-dark bg-dark mb-3 py-2">
      <div className="container">
        <Link to="/" className="nav-link navbar-brand">
          <b>PIMA COVID-19</b>
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className="collapse navbar-collapse ml-auto"
          id="navbarSupportedContent"
        >
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <Link to="/" className="nav-link ">
                <i className="fas fa-home" /> COVID-19 Data
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/vaccination-pima" className="nav-link ">
                <i className="fas fa-syringe" /> Vaccination
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/pima-weekly-tendency" className="nav-link ">
                <i className="fas fa-chart-line" /> 7 D. Avg. Graph
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/pima-monthly-infections" className="nav-link ">
                <i className="fas fa-chart-line" /> Monthly Infections
              </Link>
            </li>
            <Download />
            <li className="nav-item">
              <a
                className="nav-link"
                href="https://webcms.pima.gov/cms/One.aspx?portalId=169&pageId=641109"
              >
                <i className="fas fa-file-medical-alt mr-1" />
                Status Report
              </a>
            </li>

            {/*<li className="nav-item">
              <a
                href="https://webcms.pima.gov/cms/One.aspx?portalId=169&pageId=641109"
                className="nav-link  border border-custom-gray px-2"
              >
                Covid-19 Dashboard
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a onClick={logout} href="#!" className="nav-link ">
                <i className="fas fa-sign-out-alt" />{" "}
                <span className="hide-sm">Logout</span>
              </a>
            </li> */}
          </ul>
        </div>
      </div>
    </nav>
  );
};

NavbarLayout.propTypes = {
  // logout: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(NavbarLayout);
